export function SectionMark({
  label,
  tone = "light",
}: {
  number?: string;
  label: string;
  tone?: "light" | "dark";
}) {
  return (
    <div className="flex items-baseline gap-4">
      <p className={tone === "dark" ? "eyebrow-light" : "eyebrow"}>{label}</p>
    </div>
  );
}
